/*
|--------------------------------------------------------------------------
| App.JS
|
| Import statements must go at the top before any other code
|--------------------------------------------------------------------------
*/

// Automatically includes JS from the /components dirctory
import autoTemplateComponent from './core/auto-template-component'
import { pseudoHas } from './utilities/polyfills'
import menuMenu from '../../components/header/nav-primary/nav-primary'
import './utilities/forms'

window.THEME_PATH = '/wp-content/themes/jerseyheritage'

window.addEventListener('DOMContentLoaded', () => {
  autoTemplateComponent()

  menuMenu({
    container: 'js-nav-primary',
  })

  pseudoHas({
    nodes: '.section-pad',
    selector: '.label-pad',
    activeClass: 'section-pad-polyfill',
  })
})
